/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
} from "@mui/material";
import React, { useContext } from "react";
import { BusinessPartnerListForBcBeta } from "src/entity/recon-entity/ReconInterfaces";
import { PartnerCommsContext } from "../../../Context/PartnerCommunicationContext";
import BcNewContext from "../BcNewContext";

interface MultipleCommunicationTypesProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  setOpenBcNewMailing: (open: boolean) => void;
  setActiveStep: (activeStep: number) => void;
}

const MultipleCommunicationTypes = ({
  open,
  setOpen,
  setOpenBcNewMailing,
  setActiveStep,
}: MultipleCommunicationTypesProps) => {
  const { mailingRows, setMailingRows } = useContext(BcNewContext);
  const { setCommunicationTypeId } = useContext(PartnerCommsContext);

  const categorizedRows = mailingRows.reduce((acc, row) => {
    const { communicationTypeName } = row;
    if (!communicationTypeName) {
      if (!acc["No Communication Type"]) {
        acc["No Communication Type"] = [];
      }
      acc["No Communication Type"].push(row);
      return acc;
    }
    if (!acc[communicationTypeName]) {
      acc[communicationTypeName] = [];
    }
    acc[communicationTypeName].push(row);
    return acc;
  }, {} as Record<string, BusinessPartnerListForBcBeta[]>);

  return (
    <>
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>You have selected partners having multiple communication types</DialogTitle>
        <DialogContent sx={{ py: 2, px: 3 }}>
          <List>
            {Object.keys(categorizedRows).map((text, index) => (
              <ListItem key={index}>
                <ListItemText
                  primary={text}
                  secondary={`${categorizedRows[text]?.length} out of ${mailingRows?.length} selected Partners`}
                />
                <ListItemSecondaryAction>
                  <Button
                    variant="text"
                    color="primary"
                    size="small"
                    onClick={() => {
                      //   uiLogger(
                      //     uiLoggerNamesPartnerCommunication.UI_PC_BCB_MULTIPLE_COMMUNICATIONS_PROCEED_CLICK.functionName,
                      //     companyId,
                      //     branchCode,
                      //     {
                      //       message:
                      //         uiLoggerNamesPartnerCommunication.UI_PC_BCB_MULTIPLE_COMMUNICATIONS_PROCEED_CLICK.message,
                      //     }
                      //   );
                      setMailingRows(categorizedRows[text]);
                      setOpen(false);
                      setOpenBcNewMailing(true);
                      setCommunicationTypeId(categorizedRows[text][0].communicationTypeId);

                      // next page in the Bulk Mailing stepper if the communication type is not "No Communication Type"
                      setActiveStep(text.trim().toLowerCase() === "no communication type".toLowerCase() ? 0 : 2);
                    }}
                  >
                    PROCEED
                  </Button>
                </ListItemSecondaryAction>
              </ListItem>
            ))}
          </List>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default MultipleCommunicationTypes;
